function isEmailValid(inputText) {
  let flag = true;
  let helperText = '';
  var mailFormat =
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  if (!inputText || inputText === '') {
    flag = false;
    helperText = 'Please enter email address.';
  } else if (!String(inputText).toLowerCase().match(mailFormat)) {
    flag = false;
    helperText = 'Please enter valid email address.';
  }
  return { flag, helperText };
}

function isPhoneNumberValid(inputText) {
  let flag = true;
  let helperText = '';
  var phoneFormat = /^\d*[.]?\d*$/;
  if (!inputText || inputText === '') {
    flag = false;
    helperText = `Please enter valid phone number.`;
  } else if (!inputText.match(phoneFormat)) {
    flag = false;
    helperText = `Please enter valid phone number.`;
  } else if (inputText.length < 10 || inputText.length > 10) {
     flag = false;
     helperText = 'Please enter 10 digits only.'
  }
  return { flag, helperText };
}

function isCheckBoxFieldValid(inputText, fieldName) {
  let flag = true;
  let helperText = '';
  if (!inputText.length) {
    flag = false;
    helperText = `Please Choose ${fieldName}.`;
  }
  return { flag, helperText };
}

function isCityFieldValid(inputText) {
  let flag = true;
  let helperText = '';
  var CityFormat = /^(?![0-9]+$)[a-zA-Z0-9 ]{2,}$/;
  if (!inputText || inputText === '') {
    flag = false;
    helperText = `Please enter valid city.`;
  } else if (!inputText.match(CityFormat)) {
    flag = false;
    helperText = `Please enter valid city.`;
  } 
  return { flag, helperText };
}

function isStateFieldValid(inputText) {
  let flag = true;
  let helperText = '';
  var StateFormat = /^(?![0-9]+$)[a-zA-Z0-9 ]{2,}$/;
  if (!inputText || inputText === '') {
    flag = false;
    helperText = `Please enter valid state`;
  } else if (!inputText.match(StateFormat)) {
    flag = false;
    helperText = `Please enter valid state.`;
  } 
  return { flag, helperText };
}

function isRequiredFieldValid(inputText, fieldName) {
  console.log({ inputText, fieldName });
  let flag = true;
  let helperText = '';
  if (!inputText || inputText === '') {
    flag = false;
    helperText = `Please enter ${fieldName}.`;
  }
  return { flag, helperText };
}

function LoginPasswordIsValid(value) {
  let returnObj = {
    flag: true,
    helperText: "",
  };
  if (value === "" || !value) {
    returnObj.helperText = "Please enter the password.";
    returnObj.flag = false;
    return returnObj;
  } else {
    return returnObj;
  }
}
function passwordIsValid(value) {
  let flag = true;
  let helperText = '';
  let passwordFormat = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
                      
  if (value === '' || !value) {
    flag = false;
    helperText = 'Please enter the password.';
  } else if (!value.match(passwordFormat)) {
    flag = false;
    helperText='Min 8 characters,1 uppercase letter, 1 lowercase letter, 1 number and 1 special character';
  }
  return { flag, helperText };
}

function InputTextIsValid(inputText){
  let flag = true;
  let helperText = "";
  let FullNameFormat = /^[a-zA-Z]+[a-zA-Z]+$/;
  if(!inputText || inputText === '') {
    flag = false;
    helperText = "Please enter the full name";
  } else if(inputText.match(FullNameFormat)) {
    flag = false;
    helperText = "Please Enter 'first name' and 'last name' Only!"
  } 
  return {flag , helperText};
}

function isConfirmPasswordFieldValid(value,password) {
  let flag = true;
    let helperText = "";
    if(value === "") {
      flag = false;
      helperText = "Please enter the password.";
    } else if (value !== password) {
      flag = false;
      helperText = "Passwords don't match";
    } else {
      flag = true;
      helperText = "";
    }
    return { flag , helperText}
}


function isPinCodeValid(inputText){
  let flag = true;
  let helperText = '';
  var phoneFormat = /^\d*[.]?\d*$/;
  if (!inputText || inputText === '') {
    flag = false;
    helperText = `Please enter valid pin code.`;
  } else if (!inputText.match(phoneFormat)) {
    flag = false;
    helperText = `Please enter valid pin code.`;
  } else if (inputText.length < 6 || inputText.length > 6) {
     flag = false;
     helperText = 'Please enter 6 digits only.'
  }
  return { flag, helperText };
}

export {
  isEmailValid,
  isPhoneNumberValid,
  isCheckBoxFieldValid,
  isRequiredFieldValid,
  passwordIsValid,
  LoginPasswordIsValid,
  InputTextIsValid,
  isConfirmPasswordFieldValid,
  isPinCodeValid,
  isCityFieldValid,
  isStateFieldValid,
};
